import * as React from "react";
import { Typography, Box, Skeleton, useTheme } from "@mui/material";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";

import AvatarList from "../../AvatarList";
import CustomCard from "../../CustomCard";
import CustomCircleButton from "../../CustomCircleButton";

const LoadingCart = ({ type }) => {
  const theme = useTheme();

  return (
    <>
      {Array(3)
        .fill("")
        .map((e, i) => {
          return (
            <CustomCard
              key={i}
              pSize={16}
              shadowSize={4}
              radius={16}
              maxHeight={256}
              mBottom={16}
            >
              <Box>
                <Box sx={{ display: "flex", alignItems: "center", mb: "6px" }}>
                  {type === "discussion" ? (
                    <AvatarList type='discussion' />
                  ) : (
                    <>
                      <Skeleton variant='circular' width={24} height={24} />{" "}
                      <Box sx={{ ml: "6px" }}>
                        <Skeleton width={50} height={15} />
                      </Box>
                    </>
                  )}
                </Box>
                <Typography
                  sx={{
                    fontFamily: "Tahrir",
                    fontWeight: "700",
                    lineHeight: "32px",
                    fontSize: "32px",
                    marginBottom: "8px",
                    color: "black.main",
                  }}
                >
                  <Skeleton width='50%' height={35} />
                </Typography>
                <Typography
                  sx={{
                    fontSize: "16px",
                    lineHeight: "24px",
                    whiteSpace: "break-spaces",
                    overflow: "hidden",
                    maxHeight: "98px",
                    color: "black.main",
                  }}
                >
                  <Skeleton width='100%' height={22} />
                  <Skeleton width='100%' height={22} />
                  {type === "opinion" && <Skeleton width='100%' height={22} />}
                  <Skeleton width='40%' height={22} />
                </Typography>
              </Box>

              <Box
                sx={{
                  borderTop: "2px solid",
                  borderColor: "black.main",
                  marginTop: "16px",
                  paddingTop: "8px",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Skeleton width={70} height={28} />

                  <Box
                    sx={{ width: "24px", height: "24px", textAlign: "right" }}
                  >
                    <CustomCircleButton
                      width='22px'
                      height='22px'
                      bgColor='primary.main'
                      hoverBgColor='primary.main'
                      hoverColor='black.main'
                      hoverBorder={`none`}
                      bShadow={`0px 2px 0px ${theme.palette.black.main}`}
                      activeBgColor='black.main'
                      activeColor='white.main'
                    >
                      <KeyboardArrowRightRoundedIcon
                        sx={{ pl: "2px", fontSize: 20 }}
                      />
                    </CustomCircleButton>
                  </Box>
                </Box>
              </Box>
            </CustomCard>
          );
        })}
    </>
  );
};
export default LoadingCart;
